import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccTeam } from '../acc-teams-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: AcceleratorAreaService): GridSetup<AccTeam> {

	return {
		rowName: { singular: 'Team', plural: 'Teams' },
		getRowKey: row => '' + row.accTeamId,
		stateKey: 'accelerator-teams-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
